module.exports = __webpack_public_path__ + "img/ctrl-hadamard-stub-down--i.2f63db4d.svg";